/*
 * DEVIANT free shaker
 * When the cart has a box (THE DEVIANT / THE ALIBI / gift versions) AND a discount code,
 * this adds the Deviant 100 Shaker to the cart. If the code makes the shaker free, it stays.
 * If the code doesn't cover the shaker (e.g. some other promo code), the shaker is removed
 * again, so nobody is ever charged for a shaker they didn't ask for.
 * Config comes from snippets/deviant-free-shaker.liquid.
 */
(function () {
  var cfg = window.DeviantFreeShaker;
  if (!cfg || !cfg.shakerVariantId) return;

  var SHAKER = Number(cfg.shakerVariantId);
  var BOXES = cfg.boxHandles || [];
  var KEY = 'dv-free-shaker-tried';
  var running = false;

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }
  function shakerLine(cart) {
    return cart.items.find(function (i) { return i.variant_id === SHAKER; });
  }
  function isOurs(line) {
    return line && line.properties && line.properties._dv_free_shaker === 'yes';
  }
  function removeLine(line) {
    return post('/cart/change.js', { id: line.key, quantity: 0 });
  }
  function tried() {
    try { return sessionStorage.getItem(KEY) || ''; } catch (e) { return ''; }
  }
  function markTried(v) {
    try { sessionStorage.setItem(KEY, v); } catch (e) {}
  }

  // Hide the + / - buttons on the free shaker line, so it always stays at 1.
  var freeKey = null;
  function hideStepper() {
    if (!freeKey) return;
    var rows = document.querySelectorAll('[data-key="' + freeKey + '"]');
    for (var i = 0; i < rows.length; i++) {
      var qs = rows[i].querySelectorAll('.quantity-selector');
      for (var j = 0; j < qs.length; j++) qs[j].style.display = 'none';
    }
  }
  if (window.MutationObserver) {
    new MutationObserver(hideStepper).observe(document.documentElement, { childList: true, subtree: true });
  }

  function check() {
    if (running) return;
    running = true;
    getCart()
      .then(function (cart) {
        var hasBox = cart.items.some(function (i) { return BOXES.indexOf(i.handle) !== -1; });
        var codes = (cart.discount_codes || []).map(function (d) { return d.code.toUpperCase(); }).sort().join(',');
        var line = shakerLine(cart);
        freeKey = line && (isOurs(line) || line.final_price === 0) ? line.key : null;
        hideStepper();

        // Only one free shaker per order: if the quantity somehow goes above 1, set it back to 1.
        // (Checked BEFORE clean-up so the shaker is never removed by accident.)
        if (line && line.quantity > 1 && (isOurs(line) || line.final_price === 0)) {
          return post('/cart/change.js', { id: line.key, quantity: 1 }).then(function () { location.reload(); });
        }

        // Clean-up: a shaker we added must stay free and must have a box with it.
        if (isOurs(line) && (!hasBox || !codes || line.final_line_price > 0)) {
          if (codes) markTried(codes);
          return removeLine(line).then(function () { location.reload(); });
        }

        if (line && codes) markTried(codes); // so it won't re-add if they delete it
        if (!hasBox || !codes || line) return;
        if (tried() === codes) return; // already tried this code, it didn't cover the shaker

        markTried(codes);
        return post('/cart/add.js', {
          items: [{ id: SHAKER, quantity: 1, properties: { _dv_free_shaker: 'yes' } }],
        })
          .then(getCart)
          .then(function (after) {
            var added = shakerLine(after);
            if (!added) return;
            if (added.final_line_price > 0) {
              return removeLine(added); // code doesn't make it free, take it back out quietly
            }
            location.reload(); // show the free shaker in the cart
          });
      })
      .catch(function () {})
      .then(function () { running = false; });
  }

  // When a code is typed into the cart's discount box, put the shaker in the cart FIRST,
  // so a shaker code is accepted instead of showing "doesn't apply". If the code turns out
  // not to cover the shaker, check() takes the shaker back out afterwards.
  function prepForDiscount() {
    return getCart().then(function (cart) {
      var hasBox = cart.items.some(function (i) { return BOXES.indexOf(i.handle) !== -1; });
      if (!hasBox || shakerLine(cart)) return;
      return origFetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: SHAKER, quantity: 1, properties: { _dv_free_shaker: 'yes' } }] }),
      });
    });
  }

  // Re-check whenever the theme changes the cart (add, quantity change, discount code).
  var origFetch = window.fetch;
  var timer;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var self = this;
    var args = arguments;
    var addsCode = false;
    if (/\/cart\/update/.test(url) && init && typeof init.body === 'string') {
      try {
        var b = JSON.parse(init.body);
        addsCode = typeof b.discount === 'string' && b.discount.length > 0;
      } catch (e) {}
    }
    var p = addsCode
      ? prepForDiscount().catch(function () {}).then(function () { return origFetch.apply(self, args); })
      : origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update)/.test(url) && !running) {
      p.then(function () {
        clearTimeout(timer);
        timer = setTimeout(check, 400);
      });
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
})();
